import React, { useContext } from "react";
import { Chart } from "react-chartjs-2";
import { ThemeContext } from "../../../../context/ThemeContext";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController, // Add this
  LineController, // Add this
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController, // Add this
  LineController, // Add this
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const MultiChart = ({ multiChartData }) => {
  const theme = useContext(ThemeContext);
  const maxValueArray = [],
    minValueArray = [],
    avgValueArray = [];

  const chartData = multiChartData?.chart_value?.map((chartVal) => {
    maxValueArray.push(chartVal.max_value);
    minValueArray.push(chartVal.min_value);
    avgValueArray.push(chartVal.avg_value);
  });

  const labelColor = theme === "lite" ? "black" : "white"; // Evaluate the theme
  const data = {
    // labels: ["January", "February", "March", "April", "May", "June", "July"],
    labels: multiChartData?.chart_Label,
    datasets: [
      {
        type: "line", // Specify line chart type
        label: "Avg Value",
        data: avgValueArray || [],
        borderColor: "rgba(53, 162, 235, 1)",
        borderWidth: 4,
        fill: false,
      },
      //   {
      //     type: "bar", // Specify bar chart type
      //     label: "Bar Dataset",
      //     data: [65, 59, 80, 81, 56, 55, 40],
      //     backgroundColor: "rgba(255, 99, 132, 1)",
      //   },
      {
        type: "bar", // Specify bar chart type
        label: "Max Value",
        data: maxValueArray || [],
        backgroundColor: "#6635eb",
      },
      {
        type: "bar", // Specify bar chart type
        label: "Min Value",
        data: minValueArray || [],
        backgroundColor: "rgba(255, 99, 132, 1)",
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: labelColor, // Change legend label color
        },
      },
      // title: {
      //   display: true,
      //   text: "Combo Chart (Bar + Line) Example",
      //   color: labelColor, // Change title color
      // },
    },
    scales: {
      x: {
        ticks: {
          color: labelColor, // Change X-axis label color
        },
        title: {
          display: true,
          text: "Dates",
          color: labelColor, // Change X-axis title color
        },
      },
      y: {
        beginAtZero: false,
        ticks: {
          color: labelColor, // Change Y-axis label color
        },
        title: {
          display: true,
          text: "Value",
          color: labelColor, // Change Y-axis title color
        },
      },
    },
  };

  return (
    <div style={{ height: "500px" }}>
      <Chart type="bar" data={data} options={options} />
    </div>
  );
};

export default MultiChart;
